import { 
	CustomerQuoteWrapper,
	CustomerQuoteContent,
	CustomerQuoteHeader,
	CustomerQuoteLogo,
	CustomerQuoteQuote,
	CustomerQuoteAuthor,
	CustomerQuoteJobTitle,
	CustomerQuoteFooter,
	CustomerQuoteLearnMoreLink,
	CustomerQuoteReadMoreLink,
	CustomerQuoteReadMoreWrapper,
	CustomerQuoteVector
} from './CustomerQuote.styled';
import { Icon } from '../icon/Icon';
import DOMPurify from 'dompurify';
import { LinkButton } from '../button/LinkButton';

interface Props {
	logo: string;
	quote: string;
	author: string;
	jobTitle: string;
	learnMoreLink: string;
	learnMoreLinkLabel: string;
	learnMoreLinkTarget: boolean;
	readMoreLink: string;
	readMoreLinkLabel: string;
	readMoreLinkTarget: boolean;
	readMoreLinkHelper: string;
	backgroundColor: string;
	vectorUrl: string;
}

export const CustomerQuote = ({ 
	logo,
	quote,
	author,
	jobTitle,
	learnMoreLink,
	learnMoreLinkLabel,
	learnMoreLinkTarget,
	readMoreLink,
	readMoreLinkLabel,
	readMoreLinkTarget,
	readMoreLinkHelper,
	backgroundColor,
	vectorUrl,
}: Props) => {
	const sanitizedVectorUrl = DOMPurify.sanitize(vectorUrl);
	return (
		<CustomerQuoteWrapper>
			<CustomerQuoteContent $background_color={backgroundColor}>
				<CustomerQuoteHeader>
					<CustomerQuoteLogo src={logo} />
					<CustomerQuoteQuote>{quote}</CustomerQuoteQuote>
					<CustomerQuoteAuthor>{author}</CustomerQuoteAuthor>
					<CustomerQuoteJobTitle>{jobTitle}</CustomerQuoteJobTitle>
				</CustomerQuoteHeader>
				{learnMoreLink && (
					<CustomerQuoteFooter>
						<CustomerQuoteLearnMoreLink href={learnMoreLink}
							target={learnMoreLinkTarget ? '_blank' : '_self'}>
							{learnMoreLinkLabel}
							<Icon icon="external-link" />
						</CustomerQuoteLearnMoreLink>
					</CustomerQuoteFooter>
				)}
				<CustomerQuoteVector>
					<div dangerouslySetInnerHTML={{ __html: sanitizedVectorUrl }} />
				</CustomerQuoteVector>
			</CustomerQuoteContent>
			{readMoreLink && (
				<>
					<CustomerQuoteReadMoreWrapper>
						{readMoreLinkHelper}
					</CustomerQuoteReadMoreWrapper>

					<CustomerQuoteReadMoreLink>
						<LinkButton
							variant="white"
							size="default"
							iconPosition="right"
							label={readMoreLinkLabel}
							href={readMoreLink}
							target={readMoreLinkTarget ? '_blank' : '_self'}
							icon="external-link"				
						/>
					</CustomerQuoteReadMoreLink>
				</>
			)}
		</CustomerQuoteWrapper>
	);
};
